// extracted by mini-css-extract-plugin
module.exports = {"button":"ShareButton_button__1nyU-","primary":"ShareButton_primary__2fetR","secondary":"ShareButton_secondary__2_23E"};